<template>
  <v-badge color="red" class="mr-4" v-show="total">
    <template v-slot:badge>
      <span>{{ total }}</span>
    </template>
    <v-icon @click.stop="$router.push('/notificacoes')">notifications</v-icon>
  </v-badge>
</template>

<script>
import { notificacaoService } from '@/domain/notificacao/NotificacaoService';

export default {
  name: 'IconNotificacao',
  data: () => ({
    interval: null,
    total: 0
  }),
  methods: {
    async inicializaNotificacoes() {
      clearInterval(this.interval);
      this.interval = setInterval(async () => {
        const response = await notificacaoService.getCountNotificacoesPendente();
        const { Total } = response.data;
        this.total = Total;
      }, 120000);
    },
    async fetchTotalNotificacoesPendente() {
      const response = await notificacaoService.getCountNotificacoesPendente();
      const { Total } = response.data;
      this.total = Total;
    }
  },
  async mounted() {
    await this.fetchTotalNotificacoesPendente();
    this.inicializaNotificacoes();
  }
}
</script>

<style>

</style>